var map = {
	"./cn_CH.json": "./app/utils/langs/locales/cn_CH.json",
	"./en_US.json": "./app/utils/langs/locales/en_US.json",
	"./ko_KR.json": "./app/utils/langs/locales/ko_KR.json"
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./app/utils/langs/locales lazy recursive ^\\.\\/.*\\.json$";
module.exports = webpackAsyncContext;